
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot_password",
      function () {
        return require("private-next-pages/forgot_password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forgot_password"])
      });
    }
  